export const NOTIFY_USER = 'NOTIFY_USER';
export const DISABLE_BALANCE_ON_ADD = 'DISABLE_BALANCE_ON_ADD';
export const DISABLE_BALANCE_ON_EDIT = 'DISABLE_BALANCE_ON_EDIT';
export const ALLOW_REGISTRATION = 'ALLOW_REGISTRATION';



// WEBPACK FOOTER //
// ./src/actions/types.js